import { useRef, useState } from 'react';

export function formatCouponSerial(value) {
  const characters = String(value).replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  return characters.match(/.{1,4}/g)?.join('-') ?? '';
}

export default function CouponSerialInput({ value, onValueChange, ...props }) {
  const composing = useRef(false);
  const [compositionDraft, setCompositionDraft] = useState(null);

  const commit = (input, rawValue, cursor) => {
    const prefix = rawValue.slice(0, cursor);
    const count = prefix.replace(/[^a-zA-Z0-9]/g, '').length;
    const formatted = formatCouponSerial(rawValue);
    // Keep the caret beside the same character, including at group boundaries.
    const separators = count ? Math.floor((count - 1) / 4) : 0;
    const position = Math.min(formatted.length, count + separators + (prefix.endsWith('-') ? 1 : 0));
    input.value = formatted;
    onValueChange(formatted);
    input.setSelectionRange(position, position);
  };

  return (
    <input
      {...props}
      type="text"
      value={compositionDraft ?? value}
      autoCapitalize="characters"
      autoCorrect="off"
      spellCheck={false}
      onCompositionStart={(event) => {
        composing.current = true;
        setCompositionDraft(event.currentTarget.value);
      }}
      onCompositionEnd={(event) => {
        composing.current = false;
        setCompositionDraft(null);
        commit(event.currentTarget, event.currentTarget.value, event.currentTarget.selectionStart ?? 0);
      }}
      onChange={(event) => {
        if (composing.current || event.nativeEvent.isComposing) {
          setCompositionDraft(event.currentTarget.value);
          return;
        }
        commit(event.currentTarget, event.currentTarget.value, event.currentTarget.selectionStart ?? 0);
      }}
      onKeyDown={(event) => {
        if (composing.current || event.nativeEvent.isComposing) return;
        const input = event.currentTarget;
        const start = input.selectionStart;
        if (start === null || start !== input.selectionEnd) return;
        if (event.key === 'Backspace' && input.value[start - 1] === '-') {
          event.preventDefault();
          commit(input, input.value.slice(0, start - 2) + input.value.slice(start), start - 2);
        } else if (event.key === 'Delete' && input.value[start] === '-') {
          event.preventDefault();
          commit(input, input.value.slice(0, start) + input.value.slice(start + 2), start);
        }
      }}
    />
  );
}
